/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListSigintSensorsResult,
  ListSigintSensorsResult$inboundSchema,
} from "../components/listsigintsensorsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListSigintSensorsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListSigintSensorsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListSigintSensorsSecurity = {
  option1?: ListSigintSensorsSecurityOption1 | undefined;
  option2?: ListSigintSensorsSecurityOption2 | undefined;
};

export type ListSigintSensorsRequest = {
  /**
   * Sensor ID after which to continue
   */
  cursor?: string | undefined;
  /**
   * Page size
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListSigintSensorsResponse = {
  result: ListSigintSensorsResult;
};

/** @internal */
export type ListSigintSensorsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListSigintSensorsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListSigintSensorsSecurityOption1$Outbound,
  ListSigintSensorsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listSigintSensorsSecurityOption1ToJSON(
  listSigintSensorsSecurityOption1: ListSigintSensorsSecurityOption1,
): string {
  return JSON.stringify(
    ListSigintSensorsSecurityOption1$outboundSchema.parse(
      listSigintSensorsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListSigintSensorsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListSigintSensorsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListSigintSensorsSecurityOption2$Outbound,
  ListSigintSensorsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listSigintSensorsSecurityOption2ToJSON(
  listSigintSensorsSecurityOption2: ListSigintSensorsSecurityOption2,
): string {
  return JSON.stringify(
    ListSigintSensorsSecurityOption2$outboundSchema.parse(
      listSigintSensorsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListSigintSensorsSecurity$Outbound = {
  Option1?: ListSigintSensorsSecurityOption1$Outbound | undefined;
  Option2?: ListSigintSensorsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListSigintSensorsSecurity$outboundSchema: z.ZodMiniType<
  ListSigintSensorsSecurity$Outbound,
  ListSigintSensorsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListSigintSensorsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListSigintSensorsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listSigintSensorsSecurityToJSON(
  listSigintSensorsSecurity: ListSigintSensorsSecurity,
): string {
  return JSON.stringify(
    ListSigintSensorsSecurity$outboundSchema.parse(listSigintSensorsSecurity),
  );
}

/** @internal */
export type ListSigintSensorsRequest$Outbound = {
  cursor?: string | undefined;
  limit: number;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListSigintSensorsRequest$outboundSchema: z.ZodMiniType<
  ListSigintSensorsRequest$Outbound,
  ListSigintSensorsRequest
> = z.pipe(
  z.object({
    cursor: z.optional(z.string()),
    limit: z._default(z.int(), 50),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listSigintSensorsRequestToJSON(
  listSigintSensorsRequest: ListSigintSensorsRequest,
): string {
  return JSON.stringify(
    ListSigintSensorsRequest$outboundSchema.parse(listSigintSensorsRequest),
  );
}

/** @internal */
export const ListSigintSensorsResponse$inboundSchema: z.ZodMiniType<
  ListSigintSensorsResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListSigintSensorsResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listSigintSensorsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListSigintSensorsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSigintSensorsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSigintSensorsResponse' from JSON`,
  );
}
